export const lastCalled = (s) => {
    return s.lastCalled
}

export const oldLogs = (s) => {
    return s.oldLogs
}

export const newLogs = (s) => {
    return s.newLogs
}

export const members = (s) => {
    return s.members
}

export const cacheTime = (s) => {
    return s.cacheTime
}

export const logs = s => (id) => {
    return s.logs[id] || false
}

export const logEntries = s => (id) => {
    let d = s.logs[id] || false
    
    if(d === false || !d.data.length) {
        return {
            logs: [],
            noOldLogs: false
        }
    }
    
    return {
        logs: d.data,
        noOldLogs: d.noOldLogs
    }
}

export default {
    lastCalled,
    oldLogs,
    newLogs,
    members,
    cacheTime,
    logs,
    logEntries
}
